(function (upp) {
    'use strict';
    upp
        .service('ordersService', ['$q','appi',
            function ($q, appi) {

                var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "orders";

                /**
                 * @method listOrders
                 * @returns {Promise}
                 */
                var listOrders = function () {
                    return appi.http.getSecure(URL_API_REST_SERVER);
                };

                /**
                 * @method retrieveOrder
                 * @param orderId
                 * @returns {Promise}
                 */
                var retrieveOrder = function (orderId) {
                    return appi.http.getSecure(URL_API_REST_SERVER + '/' + orderId);
                };

                /**
                 * @method hasPendingOrders
                 * @returns {Promise} if fullfilled -> {Boolean}
                 */
                var hasPendingOrders = function () {
                    var defer = $q.defer();
                    appi.http.getSecure(URL_API_REST_SERVER + '/pending')
                        .then(function(response){
                            var hasPendingOrders = response.data && response.data.orders && response.data.orders.length;
                            defer.resolve(hasPendingOrders);
                        }, function(error){
                            defer.reject(error);
                        });
                    return defer.promise;
                };

                return {
                    listOrders:listOrders,
                    retrieveOrder:retrieveOrder,
                    hasPendingOrders:hasPendingOrders
                }
            }])
    ;
})(upp);


// WEBPACK FOOTER //
// ./src/app/plugins/orders/services/orders-service.js